const collections = [
  { title: '七月新番速递', desc: '本季最新连载漫画第一时间同步，热门新番一网打尽', count: '48部', color: 'bg-accent-100 text-accent-700', icon: 'ri-sun-line' },
  { title: '国漫精选', desc: '国产漫画口碑佳作合集，从古风到科幻题材全覆盖', count: '126部', color: 'bg-primary-100 text-primary-700', icon: 'ri-flag-2-line' },
  { title: 'JUMP系连载', desc: '周刊少年JUMP连载作品追踪，海贼王咒术回战等', count: '35部', color: 'bg-secondary-100 text-secondary-700', icon: 'ri-fire-line' },
  { title: '悬疑推理馆', desc: '高智商对决与烧脑剧情，让你追更停不下来的推理漫', count: '62部', color: 'bg-accent-100 text-accent-700', icon: 'ri-search-eye-line' },
  { title: '恋爱甜宠漫', desc: '从校园到职场，甜蜜治愈的恋爱漫画追更精选', count: '89部', color: 'bg-primary-100 text-primary-700', icon: 'ri-heart-pulse-line' },
  { title: '异世界穿越', desc: '转生、召唤、游戏世界，异世界题材漫画追更全集', count: '73部', color: 'bg-secondary-100 text-secondary-700', icon: 'ri-earth-line' },
  { title: '完结佳作补课', desc: '已完结的高分漫画推荐，一次性追完不等待', count: '55部', color: 'bg-accent-100 text-accent-700', icon: 'ri-check-double-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            追更专题
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            按题材和热度精心整理的漫画追更专题，快速找到你想追的漫画
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.slice(0, 4).map((item, i) => (
            <a key={i} href="#index" className="group block p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className={`w-12 h-12 rounded-xl ${item.color} flex items-center justify-center mb-4`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500 bg-primary-50 px-3 py-1 rounded-full">{item.count}</span>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {collections.slice(4, 7).map((item, i) => (
            <a key={i} href="#index" className="group flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className={`w-12 h-12 rounded-xl ${item.color} flex items-center justify-center flex-shrink-0`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 truncate">{item.desc}</p>
                <span className="text-xs font-medium text-primary-500">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}